/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { MESSAGING_STATE_ICONS } from 'cio/utils/email-states';
import ActionModel from 'cio/models/action';

interface SendingBehaviorIconArgs {
  action: ActionModel;
  disablePopover: boolean;
  extraClasses?: string; // When invoked with the {{component}} helper, we need a way to pass in extra classes
}

export default class SendingBehaviorIcon extends Component<SendingBehaviorIconArgs> {
  get disablePopover() {
    return this.args.disablePopover ?? false;
  }

  messagingStateIcons = MESSAGING_STATE_ICONS;
}
